import React from "react"
import styled from "styled-components"
import Inner from "../../../dsm/layout/Inner"
import Button from "../../../dsm/buttons"
import getFlexiOptionsBranding from "../../../options/getFlexiOptionsBranding"
import { getInverseColour, getWrapper } from "../../../utils"
import FluidImage from "../../../components/Images/FluidImage"

///////////////////////////////////////
// 🛠 Component
///////////////////////////////////////
const BenefitsLayoutB = ({
  inBox,
  title,
  gridGap,
  benefits,
  iconSize,
  vSpacing,
  textColour,
  description,
  contentLayout,
  backgroundImage,
  backgroundColour,
  colorHasPriority,
}) => {
  const { lightSkin } = getFlexiOptionsBranding()
  let Wrapper = getWrapper({ backgroundImage, backgroundColour })
  const classes = [contentLayout, "benefits"]

  const hasHeading = title || description

  return (
    <Wrapper>
      <Section
        inBox={inBox}
        gridGap={gridGap}
        iconSize={iconSize}
        vSpacing={vSpacing}
        lightSkin={lightSkin}
        textColour={textColour}
        className={classes.join(" ")}
        hasHeading={hasHeading.length > 0}
      >
        <Inner>
          {title && <h2 dangerouslySetInnerHTML={{ __html: title }} />}
          {description && (
            <p
              dangerouslySetInnerHTML={{ __html: description }}
              className="description"
            />
          )}
          {benefits && (
            <div className="benefits-wrapper">
              {benefits.map((benefit, i) => (
                <div
                  className={`benefit ${benefit.image ? "cols-2" : "cols-1"}`}
                  key={i}
                >
                  {benefit.image && (
                    <FluidImage
                      image={benefit.image}
                      fluid={benefit.image?.imageFile?.childImageSharp.fluid}
                      alt={benefit.image?.altText}
                    />
                  )}
                  <div>
                    {benefit.title && <h4>{benefit.title}</h4>}
                    {benefit.description && (
                      <div
                        dangerouslySetInnerHTML={{
                          __html: benefit.description,
                        }}
                      />
                    )}
                    {benefit.showButton && (
                      <Button
                        to={benefit.button.link}
                        label={benefit.button.label}
                        isExternal={benefit.button.isExternal}
                        type={benefit.button.type}
                        color={benefit.button.buttonColour || textColour}
                        icon={benefit.button.icon}
                      />
                    )}
                  </div>
                </div>
              ))}
            </div>
          )}
        </Inner>
      </Section>
    </Wrapper>
  )
}
export default BenefitsLayoutB

///////////////////////////////////////
// 💅 Styles
///////////////////////////////////////
const Section = styled.section`
  padding: ${({ vSpacing }) => `${vSpacing} 0`};
  color: ${({ textColour }) => textColour};
  h2,
  h4,
  p {
    color: ${({ textColour }) => textColour};
  }
  h2,
  .description {
    text-align: center;
  }
  &.full {
    .inner {
      max-width: ${({ theme }) => theme.maxWidth};
    }
  }
  &.skinny-heading {
    h2,
    .description {
      max-width: ${({ theme }) => theme.maxWidthSkinny};
      margin-left: auto;
      margin-right: auto;
    }
  }
  &.skinny {
    .inner {
      max-width: ${({ theme }) => theme.maxWidthSkinny};
    }
  }
  .benefits-wrapper {
    margin-top: ${({ hasHeading }) => (hasHeading ? "45px" : "0")};
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: ${({ gridGap }) => gridGap};
    grid-row-gap: ${({ inBox }) => (inBox ? "45px" : "90px")};
    .benefit {
      display: grid;
      &.cols-1 {
        grid-template-columns: 1fr;
      }
      &.cols-2 {
        grid-template-columns: ${({ iconSize }) => iconSize} 1fr;
      }
      grid-gap: 30px;
      align-items: flex-start;
      h4 {
        margin: 0 0 0.5rem 0;
      }
      padding: ${({ inBox }) => (inBox ? "25px" : "0")};
      border: ${({ inBox }) => (inBox ? "1px solid rgba(0,0,0,0.1)" : "0")};
      border-color: ${({ inBox, textColour, theme, lightSkin }) =>
        inBox
          ? textColour
            ? `${textColour}1A`
            : lightSkin
            ? theme.colors.tusk[100]
            : theme.colors.midnight[100]
          : null};
      border-radius: 8px;
      background: ${({ inBox, textColour, theme, lightSkin }) =>
        inBox
          ? textColour
            ? `${getInverseColour(textColour)}33`
            : lightSkin
            ? theme.colors.tusk[200]
            : theme.colors.midnight[200]
          : null};
    }
  }
  @media (max-width: ${({ theme }) => theme.breakSmall}) {
    .benefits-wrapper {
      grid-template-columns: 1fr;
    }
  }
`
